import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(private errorSrv: ErrorHandlerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(1),
      catchError((error) => this._triggerError(error))
    );
  }

  private _triggerError(error: HttpErrorResponse) {
    this.errorSrv.showHttpError(error.status);
    return throwError(error);
  }
}
